import { create } from "zustand";

import type { NamespaceId, NamespaceSummary } from "@/types/namespaces";

type NamespaceStoreState = {
  selectedNamespaceId: NamespaceId | null;
};

interface NamespaceStoreActions {
  setSelectedNamespaceId: (namespaceId: NamespaceId | null) => void;
  synchronizeSelection: (namespaces: NamespaceSummary[]) => NamespaceId | null;
}

export type NamespaceStore = NamespaceStoreState & NamespaceStoreActions;

export const useNamespaceStore = create<NamespaceStore>((set, get) => ({
  selectedNamespaceId: null,
  setSelectedNamespaceId: (namespaceId) => set({ selectedNamespaceId: namespaceId }),
  synchronizeSelection: (namespaces) => {
    const currentId = get().selectedNamespaceId;

    if (!namespaces.length) {
      if (currentId !== null) {
        set({ selectedNamespaceId: null });
      }
      return null;
    }

    const currentStillExists = currentId
      ? namespaces.some((ns) => ns.namespaceId === currentId)
      : false;

    const nextId = currentStillExists ? currentId : namespaces[0].namespaceId;

    if (nextId !== currentId) {
      set({ selectedNamespaceId: nextId });
    }

    return nextId;
  },
}));
